import { BoxProps } from '@mui/material';

import { SectionStyleSegment } from '@models/PageSection';

export type StylePatternSegmentProps = BoxProps & {
  discrete?: boolean;
  groupStylePattern: SectionStyleSegment;
  size?: 'large' | 'medium' | number;
};

export const baseHeightMap: Record<'large' | 'medium', number> = {
  large: 38,
  medium: 28,
};

export const isSpecialShape = (styleSegment: SectionStyleSegment): boolean => {
  switch (styleSegment) {
    case 'kids-service':
    case 'person':
      return true;
    default:
      return false;
  }
};

export const getBaseHeight = (size: StylePatternSegmentProps['size'] = 'medium') => {
  if (typeof size === 'number') return size;
  return baseHeightMap[size];
};

export const groupStylePatternSegmentIconClasses = {
  root: 'groupStylePatternSegmentIcon--root',
  discrete: 'groupStylePatternSegmentIcon--discrete',
  specialShape: 'groupStylePatternSegmentIcon--special-shape',
  svg: 'groupStylePatternSegmentIcon--svg',
};
